export default function() {
  const whereFindOutSelect = document.querySelector('select[name="where_find_out_variant"]');

  whereFindOutSelect?.addEventListener('change', function (e) {
    const ownFindOutVariant = '10';
    const currentOption = this.options[this.selectedIndex];
    const ownFindOutInput = document.querySelector('textarea[name="where_find_out"]');
    const ownFindOutInputCount = ownFindOutInput.parentNode.querySelector('.js-input-count-helper');

    if (currentOption.value === ownFindOutVariant) {
      ownFindOutInput.classList.remove('d-none');
      ownFindOutInputCount.classList.remove('d-none');
    } else {
      ownFindOutInput.classList.add('d-none');
      ownFindOutInputCount.classList.add('d-none');
    }
  });
}